import React from "react";

const PrivacyPolicy = () => {
    return (
        <div className="container mx-auto px-12 relative pt-162 min-h-calc-head py-8">
            <div className="wrapper mt-20">
                <h1 className="text-white text-3xl font-bold mb-4">Privacy Policy of Metafluence</h1>
                <p className="font-light mb-0 mb-12 text-base">
                    Metafluence is committed to protecting your privacy. This Privacy Policy explains how we collect, use,
                    and disclose your personal information in connection with your use of Metafluence.
                </p>

                <h3 className="text-gray-300 text-xl font-normal mb-4">Information We Collect</h3>
                <p className="font-light mb-0 mb-12 text-base">
                    We collect information that you provide to us, such as your name, email address, and wallet address. We
                    also collect information about your use of Metafluence, such as your interactions with other users, your
                    virtual activities, and your preferences.
                </p>

                <h3 className="text-gray-300 text-xl font-normal mb-4">Use of Metafluence</h3>
                <p className="font-light mb-0 mb-12 text-base">
                    We use the information we collect to provide and improve Metafluence, to communicate with you about
                    Metafluence and our products and services, and to personalize your experience on Metafluence. We
                    may also use your information to comply with legal obligations and to protect our rights and interests.
                </p>

                <h3 className="text-gray-300 text-xl font-normal mb-4">Disclosure of Information</h3>
                <p className="font-light mb-0 mb-12 text-base">
                    We may disclose your personal information to third parties, such as service providers, in order to provide
                    and improve Metafluence. We may also disclose your personal information to comply with legal
                    obligations or to protect our rights and interests.
                </p>

                <h3 className="text-gray-300 text-xl font-normal mb-4">Security of Information</h3>
                <p className="font-light mb-0 mb-12 text-base">
                    We take reasonable measures to protect your personal information from unauthorized access, use, or
                    disclosure. However, no method of transmission over the Internet or method of electronic storage is
                    completely secure, and we cannot guarantee absolute security
                </p>

                <h3 className="text-gray-300 text-xl font-normal mb-4">Retention of Information</h3>
                <p className="font-light mb-0 mb-12 text-base">
                    We retain your personal information for as long as necessary to provide and improve Metafluence, to
                    comply with legal obligations, and to protect our rights and interests.
                </p>

                <h3 className="text-gray-300 text-xl font-normal mb-4">Your Rights</h3>
                <p className="font-light mb-0 mb-12 text-base">
                    You have the right to access, correct, or delete your personal information. You may also have the right to
                    object to or restrict our use of your personal information. To exercise these rights, please contact us
                    using the contact information below.
                </p>

                <h3 className="text-gray-300 text-xl font-normal mb-4">Children's Privacy</h3>
                <p className="font-light mb-0 mb-12 text-base">
                    Metafluence is not intended for use by individuals under the age of 18. We do not knowingly collect
                    personal information from any individuals under the age of 18.
                </p>

                <h3 className="text-gray-300 text-xl font-normal mb-4">Changes to Privacy Policy</h3>
                <p className="font-light mb-0 mb-12 text-base">
                    We reserve the right to modify this Privacy Policy at any time. Any changes will be posted on our
                    website, and your continued use of Metafluence aPer such changes have been posted will constitute
                    your acceptance of the revised Privacy Policy.
                </p>

                <h3 className="text-gray-300 text-xl font-normal mb-4">Contact Us</h3>
                <p className="font-light mb-0 mb-12 text-base">
                    If you have any questions or concerns about this Privacy Policy, please contact us at <br/>
                    <a href="mailto:contact@metafluence.com" target="_blank" className="text-cyan-500">contact@metafluence.com</a>
                </p>
            </div>
        </div>
    )
}

export default PrivacyPolicy;